import axios from '../../axios'
import {
  takeLatest,
  call,
  put,
  select,
  take,
  fork,
  cancel
} from 'redux-saga/effects'
import { createAction, Action } from 'redux-actions'
import { actions as authActions } from '../auth/authSaga'
import {
  actionCreators as gradPlannerActionCreators,
  actions as gradPlannerActions
} from '../gradPlanner/gradPlannerSaga'
import { compressPlan } from '../../../services/compressPlan'
import { actionCreators as gradPlannerReducerActionCreators } from '../../reducers/gradPlanner/gradPlannerReducer'
// Saga action strings
export const SAVE_PLAN = 'saga/SavePlan/SAVE_PLAN'
export const SAVE_PLAN_SUCCESS = 'saga/SavePlan/SAVE_PLAN_SUCCESS'
export const SAVE_PLAN_FAILURE = 'saga/SavePlan/SAVE_PLAN_FAILURE'

export const actions = {
  SAVE_PLAN,
  SAVE_PLAN_SUCCESS,
  SAVE_PLAN_FAILURE
}

type GradPlannerSagaActionCreators = {
  savePlan: () => Action<any>,
  savePlanSuccess: () => Action<any>,
  savePlanFailure: () => Action<any>
}
export const actionCreators: GradPlannerSagaActionCreators = {
  savePlan: createAction(SAVE_PLAN),
  savePlanSuccess: createAction(SAVE_PLAN_SUCCESS),
  savePlanFailure: createAction(SAVE_PLAN_FAILURE)
}
export function * getPlan () {
  const { data: plan } = yield call(axios.get, '/plan')
  if (
    plan.school_code &&
    plan.school_code !== -1 &&
    plan.school_code !== '-1'
  ) {
    yield put(gradPlannerActionCreators.fetchCourses(plan.school_code))
    yield take(gradPlannerActions.FETCH_COURSES_SUCCESS)
    const dehydratedPlan = {
      isDirty: false,
      school: plan.school,
      endorsement: plan.endorsement,
      careerPath: plan.path,
      coreCourses: plan.coreCourses,
      requiredCourses: plan.pathCourses,
      electiveCourses: plan.electiveCourses,
      subStates: {},
      allowBack: false
    }

    yield put(
      gradPlannerReducerActionCreators.setSavedPlan(
        compressPlan(dehydratedPlan)
      )
    )
  }
}
export default function * watchSavePlan () {
  while (true) {
    yield take(authActions.LOGIN_SUCCESS)
    const savePlanTask = yield fork(savePlan)
    yield getPlan()
    yield take('Login/RESET')
    yield cancel(savePlanTask)
  }
}

export function * savePlan () {
  while (true) {
    try {
      yield take(actions.SAVE_PLAN)
      const planInfo = yield select(state => state.gradPlanner.plan)
      const repoInfo = yield call(axios.post, '/plan', {
        school_code: planInfo.school.code,
        district_code: -1,
        endorsement: planInfo.endorsement,
        path: planInfo.careerPath,
        coreCourses: planInfo.coreCourses.map(c => c.id),
        pathCourses: planInfo.requiredCourses.map(c => c.id),
        electiveCourses: planInfo.electiveCourses.map(c => c.id)
      })
      yield put(actionCreators.savePlanSuccess(repoInfo))
      yield put(gradPlannerReducerActionCreators.setDirty(false))
      yield getPlan()
    } catch (error) {
      yield put(actionCreators.savePlanFailure())
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/savePlan/savePlanSaga.js